import { ReactElement } from 'react';
import { Loader as MantineLoader } from '@mantine/core';
import type { LoaderProps as Props } from '@mantine/core';

export const Loader = ({ children, ...rest }: Props): ReactElement => {
  return <MantineLoader {...rest}>{children}</MantineLoader>;
};
